import React from 'react';
import moment from 'moment-jalali';
import { Text } from '../../kit';

export default function DateTime({ date, color = 'black', size = 'md' }) {
  return date ? (
    <Text size={size} color={color}>
      {moment(date).format('HH:mm - jYYYY/jMM/jDD')}
    </Text>
  ) : null;
}
